import React from "react";
import Dashboard from "../components/Dashboard";

/**
 * Dashboard Design Page
 * Showcases the complete dashboard layout with statistics and pricing cards
 */
export default function DashboardDesignPage() {
  return <Dashboard />;
}
